<template>
    <span>
        <button class="btn-link"
                @click="viewItem()">
            <slot name="modal-link"></slot>
        </button>
        <!-- added close directive in order to reset the modal state -->
        <modal :show.sync="modals.classic" @close="resetModal" headerClasses="justify-content-center">
        <center>
      <div class="col-md-12">
        <Header
          pageTitle="Create New Banking Office"
          class="card-container"
        ></Header>
          <div class="col-md-6">
            <label>Country</label>
            <v-select
              data-vv-as="Country"
              :class="errors.has('CountryDropdown') ? 'has-danger' : 'no'"
              :error="getError('CountryDropdown')"
              v-validate="'required'"
              v-model="bankingOffice['countryId']"
              name="CountryDropdown"
              :reduce="(item) => item.countryId"
              label="name"
              :options="countriesOptions"
              placeholder="Please select a country."
            />
            <span v-show="errors.has('CountryDropdown')" class="error">
              {{ errors.first("CountryDropdown") }}</span
            >
          </div>
          <div class="col-md-6">
            <label>Bank Name</label>
            <base-input
              data-vv-as="Bank Name"
              v-validate="'required'"
              v-model="bankingOffice['bankName']"
              name="bankName"
              placeholder="Please enter bank name."
              :error="getError('bankName')"
            />
          </div>
          <div class="col-md-6">
            <label>Bank Address</label>
            <base-input
              data-vv-as="Bank Address"
              v-validate="'required'"
              v-model="bankingOffice['bankAddress']"
              name="bankAddress"
              placeholder="Please enter bank address."
              :error="getError('bankAddress')"
            />
          </div>
          <div class="col-md-6">
            <label>Account Name/Number</label>
            <base-input
              data-vv-as="Account Name/Number"
              v-validate="'required'"
              v-model="bankingOffice['accountName']"
              name="accountNumber"
              placeholder="Please enter bank account number."
              :error="getError('accountNumber')"
            />
          </div>
          <div class="col-md-6 ">
            <label>International Bank Account Number (IBAN)</label>
            <base-input
              data-vv-as="International Bank Account Number (IBAN)"
              v-model="bankingOffice['IBAN']"
              name="bankIBAN"
              placeholder="Please enter International Bank Account Number (IBAN)."
            />
          </div>
          <div class="col-md-6">
            <label>SWIFT / ABA</label>
            <base-input
              data-vv-as="SWIFT / ABA"
              v-model="bankingOffice['SWIFT']"
              name="bankSWIFT"
              placeholder="Please enter SWIFT / ABA."
            />
          </div>

        <div class="row row justify-content-center text-center">
          <div >
            <base-button
              @click="returnToEditBankingOfficesDashboard()"
              class="btn btn-primary"
              v-b-popover.hover.bottom="
                'Navigate back to edit banking offices dashboard.'
              "
            >
              <i    class="tim-icons icon-double-left  center-btn-content "></i> Return to table
            </base-button>
          </div>
          <div >
            <base-button
              @click="addBankingOffice()"
              type="primary"
              v-b-popover.hover.bottom="'Save changes.'"
              
            >
              <i  class="tim-icons icon-bank center-btn-content"></i> Add Banking Office
            </base-button>
          </div>
        </div>
      </div>
  </center>
        </modal>
    </span>
</template>

<script>
import Header from "@/components/App/Header.vue";
import axios from "@/axios";
import {  Modal } from "@/components";
import {
    mapGetters,
    mapActions
} from "vuex";

export default {
  name: "AdminCreateBankingOffice",
  components: {
    Header,
    Modal
  },
  data() {
    return {
      bankingOffice: {
        countryId: "",
        bankName: "",
        bankAddress: "",
        SWIFT: "",
        IBAN: "",
        accountName: "",
      },
       modals: {
                    classic: false,
                },
    };
  },
  computed: {
    ...mapGetters({
      countriesOptions: "countries/allCountries",
    }),
  },
 
  methods: {
    ...mapActions({
      getAllCountries: "countries/getAllCountries",
    }),
     viewItem(){
             this.getAllCountries();
        // this.getFinanceOfficesFromBackend();
             this.modals.classic = true;
             this.errors.clear();
        },
          resetModal() {
                this.errors.clear(); // clears all validation errors
                this.$validator.reset(); // reset the validator
                this.modals = this.modals || {}; 
                this.modals.classic = false;
            },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    returnToEditBankingOfficesDashboard() {
        this.errors.clear(); // clears all validation errors
        this.$validator.reset(); // reset the validator
        this.bankingOffice.countryId= "";
        this.bankingOffice.bankName = "";
        this.bankingOffice.bankAddress= "";
        this.bankingOffice.SWIFT= "";
        this.bankingOffice.IBAN= "";
        this.bankingOffice.accountName= "";
        this.modals.classic = false;
    },
    async addBankingOffice() {
      let ctx = this;
    await this.$validator.validateAll().then(async (result) => {
      if (result) {
        await axios
          .post("api/adminbankingoffice", this.bankingOffice)
          .then((response) => {
            this.$router.push("/Admin/BankingOffices");
          })
           this.modals.classic = false;
           this.$emit("on-close", true)
      }else{
       const errors =  this.errors.all()
        this.$toast.error( errors.length > 1 ? 'Please complete required fields': errors[0]); 
      }
      });
    },
  },
};
</script>

<style scoped>
.center-btn-content {
 height:18px; margin-right: 3px
}
</style>